/**
 * What the page says when it cannot start in this browser. `unsupported` is also written into the page's HTML by
 * `bun run lang:extract`, since it must show where the page's script cannot run. The `context` keys and `reload` are
 * the notice shown while a page's WebGL context is lost (`webgl-loss.ts`).
 */
export const FLOOR = {
  unsupported: "This browser is too old to run OdysseyTales. Update it, or use a current Chrome, Firefox or Safari.",
  webgl: "This game needs WebGL, which this browser does not offer or has turned off.",
  contextLost: "The graphics stopped drawing this page. Waiting for them to come back.",
  contextGone: "The graphics did not come back. Reload the page to carry on.",
  contextGoneEditor: "The graphics did not come back. Save your work, then reload the page to carry on.",
  reload: "Reload",
} as const;
